import Layout from '../components/layout/Layout';

export default () => (
  <Layout>
    <main class="mt-10 mb-10 md:mb-32 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
      <div class="text-center">
        <h2 class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
          About
          <br class="xl:hidden" />
          <span class="text-red"> Kratos Ohio</span>
        </h2>
        <p class="mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-xl ">
          With the deregulation of select natural gas markets, consumers are given the power of
          choice. Energy providers are now able to compete for your business which results in lower
          prices and better service. At Kratos, we are pleased to have the opportunity to provide
          you with the highest standard of quality and service in the energy industry.
        </p>
        <p class="mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-xl ">
          Our team has dedicated their careers to the ins and outs of the energy business. From
          actual production at the wellhead, to the delivering of gas to your business, members of
          the Kratos team have been there every step of the way. Energy is what we know, and we
          proudly use this expertise to serve your needs.
        </p>
        <p class="mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-xl ">
          Over the years we have been serving some of the largest customers out there. From theme
          parks to grocery store chains, large customers have been enjoying our service for years.
          Now we can offer the same competitive rates to homes and small businesses. Our experience
          has given us the expertise to give your home and business, no matter how big or small, the
          best service and price.
        </p>
        <div class="mt-12 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
          <div class="rounded-md">
            <a
              href="/"
              class="mt-3 rounded-lg text-white sm:mt-0 sm:ml-3 sm:flex-shrink-0 bg-red px-14 py-3 hover:bg-darkRed transition ease-in duration-200"
            >
              Check your Zip Code
            </a>
          </div>
        </div>
      </div>
    </main>
  </Layout>
);
